import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JsonLdBuilder } from '../../structured-data.model';
import { BoelsPointOfService } from '@boels/models';

@Injectable()
export class JsonldLocalBusinessGeoBuilder
  implements JsonLdBuilder<BoelsPointOfService>
{
  build(pointOfService: BoelsPointOfService): Observable<any> {
    const geo: {
      '@type': string;
      latitude?: number;
      longitude?: number;
    } = { '@type': 'GeoCoordinates' };

    if (pointOfService.geoPoint?.latitude) {
      geo.latitude = pointOfService.geoPoint.latitude;
    }
    if (pointOfService.geoPoint?.longitude) {
      geo.longitude = pointOfService.geoPoint.longitude;
    }

    return of({ geo });
  }
}
